const actions = {
    CONTACT_GROUP_CREATE_REQUEST: 'CONTACT_GROUP_CREATE_REQUEST',
    CONTACT_GROUP_CREATE_SUCCESS: 'CONTACT_GROUP_CREATE_SUCCESS',
    CONTACT_GROUP_CREATE_ERROR: 'CONTACT_GROUP_CREATE_ERROR',
    CONTACT_GROUP_READ_LIST_REQUEST: 'CONTACT_GROUP_READ_LIST_REQUEST',
    CONTACT_GROUP_READ_LIST_SUCCESS: 'CONTACT_GROUP_READ_LIST_SUCCESS',
    CONTACT_GROUP_READ_LIST_ERROR: 'CONTACT_GROUP_READ_LIST_ERROR',
    CONTACT_GROUP_READ_REQUEST: 'CONTACT_GROUP_READ_REQUEST',
    CONTACT_GROUP_READ_SUCCESS: 'CONTACT_GROUP_READ_SUCCESS',
    CONTACT_GROUP_READ_ERROR: 'CONTACT_GROUP_READ_ERROR',
    CONTACT_GROUP_UPDATE_REQUEST: 'CONTACT_GROUP_UPDATE_REQUEST',
    CONTACT_GROUP_UPDATE_SUCCESS: 'CONTACT_GROUP_UPDATE_SUCCESS',
    CONTACT_GROUP_UPDATE_ERROR: 'CONTACT_GROUP_UPDATE_ERROR',
    CONTACT_GROUP_DELETE_REQUEST: 'CONTACT_GROUP_DELETE_REQUEST',
    CONTACT_GROUP_DELETE_SUCCESS: 'CONTACT_GROUP_DELETE_SUCCESS',
    CONTACT_GROUP_DELETE_ERROR: 'CONTACT_GROUP_DELETE_ERROR',

    CONTACT_GROUP_INIT: 'CONTACT_GROUP_INIT',
    CONTACT_GROUP_RESET: 'CONTACT_GROUP_RESET',

    CONTACT_GROUP_SET_CONTACT_IDS: 'CONTACT_GROUP_SET_CONTACT_IDS',
    CONTACT_GROUP_SET_ALL_CONTACT_IDS: 'CONTACT_GROUP_SET_ALL_CONTACT_IDS',

    createGroup: request => ({
        type: actions.CONTACT_GROUP_CREATE_REQUEST,
        request,
    }),
    readGroupList: () => ({
        type: actions.CONTACT_GROUP_READ_LIST_REQUEST,
    }),
    readGroup: id => ({
        type: actions.CONTACT_GROUP_READ_REQUEST,
        id,
    }),
    updateGroup: (id, request) => ({
        type: actions.CONTACT_GROUP_UPDATE_REQUEST,
        id,
        request,
    }),
    deleteGroup: id => ({
        type: actions.CONTACT_GROUP_DELETE_REQUEST,
        id,
    }),
    initGroup: group => ({
        type: actions.CONTACT_GROUP_INIT,
        group,
    }),
    setContactIds: selectedContactIds => ({
        type: actions.CONTACT_GROUP_SET_CONTACT_IDS,
        selectedContactIds,
    }),
    setAllContactIds: allContactIds => ({
        type: actions.CONTACT_GROUP_SET_ALL_CONTACT_IDS,
        allContactIds,
    }),
    resetState: () => ({
        type: actions.CONTACT_GROUP_RESET,
    }),
};
export default actions;
